import type { Champignons } from "@repo/types";

export const CHAMPIGNON_CATEGORY_OPTIONS = [
  { value: "F", label: "Feuillu", description: "Arbres à feuilles", icon: "🍃" },
  { value: "R", label: "Résineux", description: "Conifères", icon: "🌲" },
  { value: "FR", label: "Feuillu/Résineux", description: "Feuillus et résineux", icon: "🍃🌲" },
] as const;

export type ChampignonCategoryValue = (typeof CHAMPIGNON_CATEGORY_OPTIONS)[number]["value"];

interface ChampignonCategoryBadgeStyle {
  className: string;
}

const CHAMPIGNON_CATEGORY_BADGE_STYLES: Record<ChampignonCategoryValue, ChampignonCategoryBadgeStyle> = {
  F: {
    className: "bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100 font-medium",
  },
  R: {
    className: "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100 font-medium",
  },
  FR: {
    className: "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100 font-medium",
  },
};

export function getChampignonCategoryLabel(
  category: Champignons["category"] | string | null | undefined
): string | null {
  if (!category) {
    return null;
  }

  const option = CHAMPIGNON_CATEGORY_OPTIONS.find((item) => item.value === category);
  return option?.label ?? null;
}

export function getChampignonCategoryBadgeStyle(
  category: Champignons["category"] | string | null | undefined
): ChampignonCategoryBadgeStyle | null {
  if (!category || !(category in CHAMPIGNON_CATEGORY_BADGE_STYLES)) {
    return null;
  }

  return CHAMPIGNON_CATEGORY_BADGE_STYLES[category as ChampignonCategoryValue];
}
